const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface Upcoming {
  id: string;
  scheduledAt: string;
  durationMinutes: number;
  modality: string;
  meetLink: string | null;
  status: string;
  clientName: string;
  serviceName: string | null;
}
interface DashboardData {
  firstName: string;
  status: string;
  completeness: {
    hasBio: boolean;
    hasSpecializations: boolean;
    hasServices: boolean;
    hasAvailability: boolean;
    hasVideo: boolean;
  };
  upcoming: Upcoming[];
  reviews: {
    avgRating: number | null;
    reviewCount: number;
  };
}
interface StatsData {
  from: string;
  to: string;
  earnings: number;
  earningsChange: number | null;
  completedSessions: number;
  completedChange: number | null;
  pendingPayout: number;
  pendingPayoutSessionCount: number;
  avgRating: number | null;
  reviewCount: number;
  actionItems: TherapistActionItem[];
}